import {getToken, inAppBrowser, getWebsocketUrl} from '@/libs/util';

if (!Boolean(getToken()) && !Boolean(window.sessionStorage.getItem('goto'))) {
    if (inAppBrowser() === 'wx') {
        window.sessionStorage.setItem('goto', 'true');
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
            'appid=wxc8ad6a4b7985d4ba&' +
            'redirect_uri=' + encodeURI(window.location.protocol + '//' + window.location.host) + '&' +
            'response_type=code&' +
            'scope=snsapi_userinfo&' + //snsapi_base,snsapi_userinfo
            'state=STATE#wechat_redirect'
    }
}

import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import importDirective from '@/directive';

importDirective(Vue);

Vue.filter('milliseconds2Datetime', function (milliseconds, format) {
    return milliseconds ? new Date(milliseconds).format(format ? format : 'yyyy-MM-dd hh:mm:ss') : '';
});

/**
 * 图片懒加载
 */
import {Lazyload} from 'vant';

Vue.use(Lazyload);

/**
 * websocket连接
 */
import Websocket from 'vue-native-websocket';

Vue.use(Websocket, getWebsocketUrl(), {
    store: store,
    format: 'json',
    reconnection: true,
    connectManually: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 5000
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
